// extracted by mini-css-extract-plugin
export default {"container":"DownloadingModal_container__BtwO1","title":"DownloadingModal_title__Nxup3"};